import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import LinkButton from "components/ui/LinkButton";

type PropsType = {
    readonly logout?: boolean;
};

function ErrorUnauthorized({ logout }: PropsType) {
    return (
        <GridColumn>
            <GridItem>
                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                        <h1>Accesso non autorizzato</h1>

                        <p>La tua utenza non è autorizzata a eseguire la richiesta.</p>
                    </GridItem>
                </GridRow>

                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"}>
                        {logout ? (
                            <LinkButton
                                variant={"contained"}
                                to={"/auth/logout"}
                                label={"Accedi di Nuovo"}
                            />
                        ) : (
                            <LinkButton
                                variant={"contained"}
                                to={"/dashboard"}
                                label={"Ritorna alla dashboard"}
                            />
                        )}
                    </GridItem>
                </GridRow>
            </GridItem>
        </GridColumn>
    );
}

export default ErrorUnauthorized;
